var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAddImage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M25.333 9.333v3.987s-2.653.013-2.666 0V9.333h-4s.013-2.653 0-2.666h4v-4h2.666v4h4v2.666h-4zm-4 5.334v-4h-4v-4H6.667A2.674 2.674 0 0 0 4 9.333v16C4 26.8 5.2 28 6.667 28h16c1.466 0 2.666-1.2 2.666-2.667V14.667h-4zM6.667 25.333l4-5.333 2.666 4 4-5.333 5.334 6.666h-16z"
})));
export default SvgAddImage;